export default __webpack_public_path__ + "static/media/team.7d9dbc11.png";